import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MarketDepthMatrixModel } from './MarketDepthMatrix.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { MarketMatrixComponent } from '../../../gotx/components/MarketMatrix/MarketMatrix.component';
import { ProductComponent } from '../../components/Product/Product.component';

const customCss: string = '';

@Component({
    selector: 'app-MarketDepthMatrix',
    templateUrl: './MarketDepthMatrix.component.html'
})
export class MarketDepthMatrixComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('RefreshBtn', { static: false }) RefreshBtn: ButtonComponent;
    @ViewChild('GrpMarketDepthMatrix1', { static: false }) GrpMarketDepthMatrix1: ElementRef;
    @ViewChild('MarketDepthMatrix1', { static: false }) MarketDepthMatrix1: MarketMatrixComponent;
    @ViewChild('GrpMarketDepthMatrix2', { static: false }) GrpMarketDepthMatrix2: ElementRef;
    @ViewChild('MarketDepthMatrix2', { static: false }) MarketDepthMatrix2: MarketMatrixComponent;
    @ViewChild('grpMarketDepthMatrix3', { static: false }) grpMarketDepthMatrix3: ElementRef;
    @ViewChild('MarketDepthMatrix3', { static: false }) MarketDepthMatrix3: MarketMatrixComponent;
    @ViewChild('grpMarketDepthMatrix4', { static: false }) grpMarketDepthMatrix4: ElementRef;
    @ViewChild('MarketDepthMatrix4', { static: false }) MarketDepthMatrix4: MarketMatrixComponent;
    @ViewChild('grpMarketDepthMatrix5', { static: false }) grpMarketDepthMatrix5: ElementRef;
    @ViewChild('MarketDepthMatrix5', { static: false }) MarketDepthMatrix5: MarketMatrixComponent;
    @ViewChild('grpMarketDepthMatrix6', { static: false }) grpMarketDepthMatrix6: ElementRef;
    @ViewChild('MarketDepthMatrix6', { static: false }) MarketDepthMatrix6: MarketMatrixComponent;
    @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
    skeletonContentLoaded = false;
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.MarketDepthMatrix1.revalidate(),
            this.MarketDepthMatrix2.revalidate(),
            this.MarketDepthMatrix3.revalidate(),
            this.MarketDepthMatrix4.revalidate(),
            this.MarketDepthMatrix5.revalidate(),
            this.MarketDepthMatrix6.revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new MarketDepthMatrixModel();
        this.componentCode = 'MarketDepthMatrix';
        this.displayBorder = false;
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
        this.MarketDepthMatrix1.setReadOnly(readOnly);
        this.MarketDepthMatrix2.setReadOnly(readOnly);
        this.MarketDepthMatrix3.setReadOnly(readOnly);
        this.MarketDepthMatrix4.setReadOnly(readOnly);
        this.MarketDepthMatrix5.setReadOnly(readOnly);
        this.MarketDepthMatrix6.setReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.MarketDepthMatrix1.cstmProduct.cmbProduct.setFocus(true);
        this.setDependencies();
        this.MarketDepthMatrix1.cstmProduct.setProductDropDown();
        this.MarketDepthMatrix2.cstmProduct.setProductDropDown();
        this.MarketDepthMatrix3.cstmProduct.setProductDropDown();
        this.MarketDepthMatrix4.cstmProduct.setProductDropDown();
        this.MarketDepthMatrix5.cstmProduct.setProductDropDown();
        this.MarketDepthMatrix6.cstmProduct.setProductDropDown();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'MarketDepthMat';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
        this.additionalInfo['MarketDepthMatrix1_desc'] = this.MarketDepthMatrix1.getFieldInfo();
        this.additionalInfo['MarketDepthMatrix2_desc'] = this.MarketDepthMatrix2.getFieldInfo();
        this.additionalInfo['MarketDepthMatrix3_desc'] = this.MarketDepthMatrix3.getFieldInfo();
        this.additionalInfo['MarketDepthMatrix4_desc'] = this.MarketDepthMatrix4.getFieldInfo();
        this.additionalInfo['MarketDepthMatrix5_desc'] = this.MarketDepthMatrix5.getFieldInfo();
        this.additionalInfo['MarketDepthMatrix6_desc'] = this.MarketDepthMatrix6.getFieldInfo();
        return this.additionalInfo;
    }
    getFieldValue() {
        this.value.MarketDepthMatrix1 = this.MarketDepthMatrix1.getFieldValue();
        this.value.MarketDepthMatrix2 = this.MarketDepthMatrix2.getFieldValue();
        this.value.MarketDepthMatrix3 = this.MarketDepthMatrix3.getFieldValue();
        this.value.MarketDepthMatrix4 = this.MarketDepthMatrix4.getFieldValue();
        this.value.MarketDepthMatrix5 = this.MarketDepthMatrix5.getFieldValue();
        this.value.MarketDepthMatrix6 = this.MarketDepthMatrix6.getFieldValue();
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.MarketDepthMatrix1.setValue(inputValue['MarketDepthMatrix1'], inputDesc['MarketDepthMatrix1_desc']);
        this.MarketDepthMatrix2.setValue(inputValue['MarketDepthMatrix2'], inputDesc['MarketDepthMatrix2_desc']);
        this.MarketDepthMatrix3.setValue(inputValue['MarketDepthMatrix3'], inputDesc['MarketDepthMatrix3_desc']);
        this.MarketDepthMatrix4.setValue(inputValue['MarketDepthMatrix4'], inputDesc['MarketDepthMatrix4_desc']);
        this.MarketDepthMatrix5.setValue(inputValue['MarketDepthMatrix5'], inputDesc['MarketDepthMatrix5_desc']);
        this.MarketDepthMatrix6.setValue(inputValue['MarketDepthMatrix6'], inputDesc['MarketDepthMatrix6_desc']);
        this.value = new MarketDepthMatrixModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'MarketDepthMatrix'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'MarketDepthMatrix_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('MarketDepthMatrix_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.value.MarketDepthMatrix1 = this.MarketDepthMatrix1.getFieldValue();
            this.MarketDepthMatrix1.valueChangeUpdates().subscribe((value) => { this.value.MarketDepthMatrix1 = value; });
            this.value.MarketDepthMatrix2 = this.MarketDepthMatrix2.getFieldValue();
            this.MarketDepthMatrix2.valueChangeUpdates().subscribe((value) => { this.value.MarketDepthMatrix2 = value; });
            this.value.MarketDepthMatrix3 = this.MarketDepthMatrix3.getFieldValue();
            this.MarketDepthMatrix3.valueChangeUpdates().subscribe((value) => { this.value.MarketDepthMatrix3 = value; });
            this.value.MarketDepthMatrix4 = this.MarketDepthMatrix4.getFieldValue();
            this.MarketDepthMatrix4.valueChangeUpdates().subscribe((value) => { this.value.MarketDepthMatrix4 = value; });
            this.value.MarketDepthMatrix5 = this.MarketDepthMatrix5.getFieldValue();
            this.MarketDepthMatrix5.valueChangeUpdates().subscribe((value) => { this.value.MarketDepthMatrix5 = value; });
            this.value.MarketDepthMatrix6 = this.MarketDepthMatrix6.getFieldValue();
            this.MarketDepthMatrix6.valueChangeUpdates().subscribe((value) => { this.value.MarketDepthMatrix6 = value; });
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }

    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.MarketDepthMatrix1.clearError();
        this.MarketDepthMatrix2.clearError();
        this.MarketDepthMatrix3.clearError();
        this.MarketDepthMatrix4.clearError();
        this.MarketDepthMatrix5.clearError();
        this.MarketDepthMatrix6.clearError();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.MarketDepthMatrix1.onReset();
        this.MarketDepthMatrix2.onReset();
        this.MarketDepthMatrix3.onReset();
        this.MarketDepthMatrix4.onReset();
        this.MarketDepthMatrix5.onReset();
        this.MarketDepthMatrix6.onReset();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new MarketDepthMatrixModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async RefreshBtn_click(event) {
        this.MarketDepthMatrix1.btnSubmit_click(event);
        this.MarketDepthMatrix2.btnSubmit_click(event);
        this.MarketDepthMatrix3.btnSubmit_click(event);
        this.MarketDepthMatrix4.btnSubmit_click(event);
        this.MarketDepthMatrix5.btnSubmit_click(event);
        this.MarketDepthMatrix6.btnSubmit_click(event);
    }
    fieldDependencies = {
    }

}